import { Controller } from '@hotwired/stimulus'

export default class SignatureController extends Controller {
  static targets = [
    'iframeContainer',
    'initSignatureBtn',
    'loader',
    'beforeResponse',
    'responseSuccess',
  ];

  static values = {
    subscriptionId: Number,
    endpoint: String,
  }

  connect() {
    if (this.element.dataset.initialized) return;

    this.subscribeToSignatureChannel();
    this.element.dataset.initialized = true;
  }

  generateIframe(signerId) {
    const configuration = {};
    /**
     * The universignSigInit function add an iframe element as child of element with
     * id attribute equals to containerId parameter, the attribute src is set from
     * the universignUrl variable, it is the url of the website to be integrated in
     * the iframe, the width and height of the iframe will take 100% of its
     * container.
     *
     * @param {string} containerId The id of the element in which we will inject
     * the iframe.
     * @param {string} signerId The identifier of transaction.
     * @param {object} configuration The options list to customize the iframe:
     * * redirectionMode {string} This params have two possible values: IN or OUT,
     * the dafault value is OUT,
     * if the value of this params is equal to OUT the redirection will be done
     * outside the iframe(in website container of the iframe),
     * if the value of this params is equal to ÌN the redirection will be done
     * inside the iframe,
     * if the value of this params is otherwise, an exception will be triggered.
     */
    universignSigInit(this.iframeContainerTarget.id, signerId, configuration, this.endpointValue);
  }

  subscribeToSignatureChannel() {
    const controller = this;

    App.cable.subscriptions.create({
      channel: 'SubscriptionSignatureChannel',
      subscription_id: this.subscriptionIdValue,
    },
    {
      received(data) {
        if (data.status == 'success') {
          controller.loaderTarget.classList.add('d-none');

          if(controller.hasBeforeResponseTarget) {
            controller.beforeResponseTargets.forEach((el) => el.classList.add('d-none'));
            controller.responseSuccessTargets.forEach((el) => el.classList.remove('d-none'));
          } else {
            controller.initSignatureBtnTarget.classList.remove('d-none');
          }

          if (data.universign_version == 1) {
            controller.initSignatureBtnTarget.addEventListener('click', () => {
              controller.generateIframe(data.transaction_url.split('id=')[1]);
            })
          } else if (data.universign_version == 2) {
            controller.initSignatureBtnTarget.addEventListener('click', () => {
              window.location.href = data.transaction_url;
            })
          }

          this.unsubscribe();
        } else {
          this.unsubscribe();

          if (data.error_key == 'process_error') {
            controller.subscribeToSignatureChannel();
          } else if (data.error_key == 'already_signed' || data.error_key == 'not_valid') {
            window.location.href = data.redirect_path
          }
        }
      },
    })
  }
}
